import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { usePermissions } from "../context/PermissionsContext";
import { PosLoader } from "./pos/PosLoader";
import { hasWorkingSession } from "../api/pos/session";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { loading, canAccessRoute, getDefaultRoute } = usePermissions();
  // POS rejimində bulud token-i TƏK BAŞINA kifayət deyil: pos_local sessiyası
  // olmadan masa/sifariş/printer sorğularının hamısı 401 verir. Yalnız bulud
  // token-inə baxsaq, işçi "giriş edilib" sayılır, amma işlək olmayan ekrana
  // düşür və PIN ekranını heç vaxt görmür.
  if (!hasWorkingSession()) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (loading) {
    // Əvvəl `null` qaytarırdı → tətbiq açılanda ağ ekran görünürdü.
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-white dark:bg-[#09090b]">
        <PosLoader size="lg" />
      </div>
    );
  }

  if (!canAccessRoute(location.pathname)) {
    const fallbackRoute = getDefaultRoute();
    const redirectTo = fallbackRoute && fallbackRoute !== location.pathname ? fallbackRoute : "/";
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;


